module.exports = __webpack_public_path__ + "static/WEDDING E&M-251-7f7f52e4d72fd99af01adea58a4b6638.jpg";